export const SEARCH_USERS_PENDING = 'SEARCH_USERS_PENDING';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_ERROR = 'SEARCH_USERS_ERROR';
export const GET_USERS_PENDING = 'GET_USERS_PENDING';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const UPDATE_USER_PENDING = 'UPDATE_USER_PENDING';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const CREATE_USER_PENDING = 'CREATE_USER_PENDING';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';
export const GET_USER_PENDING = 'GET_USER_PENDING';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const REMOVE_USER_PENDING = 'REMOVE_USER_PENDING';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';
export const GET_USER_BY_TOKEN_PENDING = 'GET_USER_BY_TOKEN_PENDING';
export const GET_USER_BY_TOKEN_SUCCESS = 'GET_USER_BY_TOKEN_SUCCESS';
export const GET_USER_BY_TOKEN_ERROR = 'GET_USER_BY_TOKEN_ERROR';

export function getUsersPending() {
  return { type: GET_USERS_PENDING }
};

export function getUsersSuccess(payload) {
  return { type: GET_USERS_SUCCESS, payload }
};

export function getUsersError(error) {
  return { type: GET_USERS_ERROR, error }
};

export function getUserPending() {
  return { type: GET_USER_PENDING }
};

export function getUserSuccess(payload) {
  return { type: GET_USER_SUCCESS, payload }
};

export function getUserError(error) {
  return { type: GET_USER_ERROR, error }
};

export function getUserByTokenPending(payload) {
  return { type: GET_USER_BY_TOKEN_PENDING, payload }
};

export function getUserByTokenSuccess(payload) {
  return { type: GET_USER_BY_TOKEN_SUCCESS, payload }
};

export function getUserByTokenError(error) {
  return { type: GET_USER_BY_TOKEN_ERROR, error }
};

export function createUserByTokenSuccess(payload) {
  return { type: CREATE_USER_SUCCESS, payload }
};

export function createUserByTokenError(error) {
  return { type: CREATE_USER_ERROR, error }
};

export function createUserPending() {
  return { type: CREATE_USER_PENDING }
};

export function createUserSuccess(payload) {
  return { type: CREATE_USER_SUCCESS, payload }
};

export function createUserError(error) {
  return { type: CREATE_USER_ERROR, error }
};

export function updateUserPending() {
  return { type: UPDATE_USER_PENDING }
};

export function updateUserSuccess(payload) {
  return { type: UPDATE_USER_SUCCESS, payload }
};

export function updateUserError(error) {
  return { type: UPDATE_USER_ERROR, error }
};

export function searchUsersPending() {
  return { type: SEARCH_USERS_PENDING }
};

export function searchUsersSuccess(payload) {
  return { type: SEARCH_USERS_SUCCESS, payload }
};

export function searchUsersError(error) {
  return { type: SEARCH_USERS_ERROR, error }
};

export function removeUserPending() {
  return { type: REMOVE_USER_PENDING }
};

export function removeUserSuccess(payload) {
  return { type: REMOVE_USER_SUCCESS, payload }
};

export function removeUserError(error) {
  return { type: REMOVE_USER_ERROR, error }
};
